import { render, staticRenderFns } from "./safetyHealthyTarget.vue?vue&type=template&id=537e7cf8"
import script from "./safetyHealthyTarget.vue?vue&type=script&lang=js"
export * from "./safetyHealthyTarget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('537e7cf8')) {
      api.createRecord('537e7cf8', component.options)
    } else {
      api.reload('537e7cf8', component.options)
    }
    module.hot.accept("./safetyHealthyTarget.vue?vue&type=template&id=537e7cf8", function () {
      api.rerender('537e7cf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/sht/safetyHealthyTarget.vue"
export default component.exports